import { ExchangeRateApp } from "exchangeRate/App";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const exchangeRateRoute: RouteObject = {
  path: "exchangerate",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: ExchangeRateApp,
  }]
};